import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import utils from '@/utils/utils';
import dd from '@/utils/dd';
import { base } from '@/services/api/_base';
import "./style.scss";

function BKGoods(props: any) {
  const {
    id,
    list,
    compId,
    moduleName,
    mark,
    pId,
    mallTest,
    _pvMoudel,
    _adMoudel,
  } = props;
  const [carImgH, setCarImgH] = useState<any>("auto");

  const clickBKGoods = (data: any, positionId: number) => {
    window.location.href = base.isProduct
      ? `https://mcar.mall.autohome.com.cn/frontEndPageStatic/productDetail/index.html?itemId=${data.biz_id}&sourceid=200003&test=2021&mallTest=${mallTest}${_pvMoudel}${_adMoudel}`
      : `http://pbl.terra.corpautohome.com/frontEndPageStatic/productDetail/index.html?itemId=${data.biz_id}&sourceid=200003&test=20211230&mallTest=${mallTest}${_pvMoudel}${_adMoudel}`;
    let extendParams = {
      ...dd.ep,
      providerId: pId,
      brandId: data.cms_brand_ids,
      compId,
      positionId,
      goodId: data.biz_id,
      mallTest,
    };
    extendParams = utils.formatParams(extendParams);
    utils.pvTrackLogger(
      "click",
      "ec_topic_mall_bkshangpin_click",
      dd.baseParams,
      extendParams
    );
  };

  useEffect(() => {
    if (list.length > 0 && mark.pageType === "mall") {
      list.forEach((v: any, k: number) => {
        // 曝光埋点
        let extendParams = {
          ...dd.ep,
          providerId: pId,
          brandId: v.data.cms_brand_ids,
          compId,
          positionId: k + 1,
          goodId: v.id,
          mallTest,
        };
        extendParams = utils.formatParams(extendParams);
        utils.pvTrackLogger(
          "show",
          "ec_topic_mall_bkshangpin_show",
          dd.baseParams,
          extendParams
        );
      });
    }
  }, [list, JSON.stringify(mark)]);

  useEffect(() => {
    // @ts-ignore
    const carImgH = document.getElementById("carImg")?.offsetWidth * 0.75;
    if (carImgH > 0) {
      setCarImgH(() => carImgH);
    }
    // @ts-ignore
  }, [document.getElementById("carImg")?.offsetWidth]);

  return (
    <div key={id} className="tabHome-item tabHome-item-BK">
      <span className="title">{moduleName}</span>
      <div className="BkGoodsList">
        {list.slice(0, 6).map((v: any, k: number) => {
          const { data } = v;
          const { commodity_type, sale_price, worth } = data;
          return (
            <div
              key={v.id}
              className="item-goods"
              onClick={() => clickBKGoods(data, k + 1)}
            >
              <div className="carInfo">
                <img
                  alt=''
                  id="carImg"
                  className="carImg"
                  src={data.img_url}
                  style={{ height: carImgH }}
                />
                <span>{data.title}</span>
              </div>
              <span className="youhui">
                {commodity_type && Number(commodity_type) === 2
                  ? sale_price
                    ? `${sale_price || ""}元抵${worth || 0}元权益`
                    : `抵${worth || 0}元权益`
                  : `${sale_price}元`}
              </span>
              <span className="btn">立即抢购</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default BKGoods;
